import { api } from 'data/api/api'
import { UsersResp } from 'types/api/response/users-resp'

import { GetFollowUsersArgs } from '../types/followed-users'

export const getFollowedUsers = ({ userId, perPage, page }: GetFollowUsersArgs) =>
  api.get<UsersResp>(`users/${userId}/followed_users`, {
    params: { per_page: perPage, page },
  })
